import { render, staticRenderFns } from "./table.vue?vue&type=template&id=3ed38a92&scoped=true&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&id=3ed38a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed38a92",
  null
  
)

export default component.exports
import {QTable,QTr,QTd,QCard,QCardSection,QIcon,QBtn,QPagination} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTr,QTd,QCard,QCardSection,QIcon,QBtn,QPagination})
